import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { exitMissionAction } from '../../../redux/screen/exitmission';
import Logo from '../../../assets/icon/favicon.png'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function LimitPopup({open,setOpen}) {
const dispatch=useDispatch()
const navigate=useNavigate()


 

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div>
      
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className='mobile__width'
      >
        <DialogTitle style={{display:"flex",justifyContent:"center"}}><img src={Logo} width="70px"/></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" style={{textAlign:"center",fontFamily:"Roboto!important"}}>
          You have exceeded your daily limit for Quiz completion. Please come back again after 12:00 A.M.
          </DialogContentText>
        </DialogContent>
        
        <DialogActions className="dailogue_bg" style={{display:"flex",justifyContent:"center"}} onClick={handleClose} >
          <Button  className="dailogue_bg"  variant='contained' >Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
